<div class="d-flex" style="height: 100%; width:100%; background:white; position:relative;">
    <div class="d-none d-md-block col-md-3 col-lg-2 sidebarContainer" >
        <app-sidebar></app-sidebar>
    </div>
    <div class="col-12 col-md-9 col-lg-10  h-100">
        <app-dashboard *ngIf="atdashboard"></app-dashboard>
        <app-admin-dashboard (showSideBar)="showSideBar($event)" *ngIf="atAdminDashboard"></app-admin-dashboard>
        <app-facility-listing (showSideBar)="showSideBar($event)" *ngIf="atFacilityListing"></app-facility-listing>
        <app-facility-info (showSideBar)="showSideBar($event)" *ngIf="atFacilityInfo"></app-facility-info>
        <app-cse-listing (showSideBar)="showSideBar($event)" *ngIf="atCseListing"></app-cse-listing>
        <app-add-cse-form (showSideBar)="showSideBar($event)" *ngIf="atAddCseForm"></app-add-cse-form>
        <app-cse-mapped-list (showSideBar)="showSideBar($event)" *ngIf="atCseMappedList"></app-cse-mapped-list>
        <app-cse-facility-mapped (showSideBar)="showSideBar($event)" *ngIf="atCseFacilityMapped"></app-cse-facility-mapped>
        <app-add-mapping-form (showSideBar)="showSideBar($event)" *ngIf="atAddMappingForm"></app-add-mapping-form>
    </div>
</div>